import React from 'react';
import { SET_ADD_MEDICATION } from 'helpers/types';
import { Formik, ErrorMessage } from 'formik';
import { AddMedicationFormContent } from 'services/content';
import { useDispatch } from 'react-redux';
import useMedicationLookUp from 'hooks/useMedicationLookUp';
import styles from './style.module.css';
import { useHistory } from 'react-router-dom';

const AddMedicationForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [medicationFromName, , , getMedicationFromName, ,] = useMedicationLookUp();
  const values = { medication: '' };

  const submitForm = async (payload, actions) => {
    try {
      await getMedicationFromName(payload.medication);
    } catch (e) {
      history.push('/pharmacy/error');
    }
  };

  const updateMedication = (e, medication) => {
    e.stopPropagation();
    dispatch({ type: SET_ADD_MEDICATION, payload: medication });
    history.push('/pharmacy/dashboard/add-medication/select');
  };

  return (
    <>
      <Formik
        initialValues={values}
        validateOnChange={false}
        validateOnBlur={false}
        onSubmit={(values, actions) => submitForm(values, actions)}>
        {(props) => (
          <form className={styles.form} onChange={props.handleSubmit}>
            <label className={styles.mb0} htmlFor="medication">
              <h4 className={styles.subHeader}>{AddMedicationFormContent.headingText}</h4>
              <p>{AddMedicationFormContent.searchLabelText}</p>
              <input
                maxLength="255"
                id="medication"
                type="text"
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                value={props.values.medication}
                className={`coop-form__input ${
                  props.errors.medication && props.touched.medication && 'coop-form__invalid'
                }`}
                name="medication"
              />
              <ErrorMessage
                name="medication"
                render={(msg) => <div className={`coop-c-form-error__text ${styles.errorText}`}>{msg}</div>}
              />
            </label>
            {props.touched.medication &&
              props.values.medication.length >= 3 &&
              medicationFromName?.names?.length === 0 && (
                <div className={`${styles.error_container}`}>
                  <h2 className={styles.error_header}>{AddMedicationFormContent.noResultsHeader}</h2>
                  <ul>
                    <li className={styles.error_text}>{AddMedicationFormContent.noResultsInfo1}</li>
                    <li className={styles.error_text}>{AddMedicationFormContent.noResultsInfo2}</li>
                    <li className={styles.error_text}>{AddMedicationFormContent.noResultsInfo3}</li>
                  </ul>
                  <p
                    className={styles.error_text}
                    dangerouslySetInnerHTML={{
                      __html: AddMedicationFormContent.noResultsText,
                    }}
                  />
                </div>
              )}
            {medicationFromName?.names?.map((medication, index) => (
              <div key={index} className={`${styles.box_container}`}>
                <div onClick={(e) => updateMedication(e, medication)}>
                  <h2 className={styles.medicationName}>{medication}</h2>
                </div>
                {medicationFromName?.names?.length !== index + 1 && <div className={styles.divider} />}
              </div>
            ))}
          </form>
        )}
      </Formik>
    </>
  );
};

export default AddMedicationForm;
